module.exports = __webpack_public_path__ + "static/img/jxapgl_header_img.637abbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jxapgl_header_img.png
// module id = epBm
// module chunks = 167